import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../index.css";

export default function NavBar() {
  const { pathname } = useLocation();
  return (
    <header className="kb-header">
      <div className="kb-brand">KiboGraph</div>
      <nav className="kb-nav">
        <Link className={pathname === "/" ? "kb-link active" : "kb-link"} to="/">Dashboard</Link>
        <Link className={pathname.startsWith("/chat") ? "kb-link active" : "kb-link"} to="/chat">Chat</Link>
        <Link className={pathname === "/docs" ? "kb-link active" : "kb-link"} to="/docs">Docs</Link>
      </nav>
    </header>
  );
}
